import { render, staticRenderFns } from "./CustomerUpdate.vue?vue&type=template&id=c4495bc4&scoped=true&"
import script from "./CustomerUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4495bc4",
  null
  
)

export default component.exports